module.exports = __webpack_public_path__ + "static/media/landing_doc.cca0e48c.png";